import { Dropdown } from "antd";
import { Link } from "react-router-dom";

export const DropdownView = ({
  component,
  items,
}: {
  component: any;
  items: any[];
}) => {
  const options = items.map((val) => {
    const { to, label } = val || {};
    let item = val;
    if (to) {
      item = { ...val, label: <Link to={to}>{label}</Link> };
    }
    return item;
  });
  return (
    <Dropdown menu={{ items: options }} trigger={["click"]}>
      <div>{component}</div>
    </Dropdown>
  );
};
